import React from 'react';
import { RicosViewer, useRicosTheme } from '@wix/form-fields';
import styles from './submit-status-message.module.scss';
import { DATA_HOOKS } from '../../tpa/widget/data-hooks';
const paragraphCustomStylesWUT = {
    p: {
        fontSize: 'var(--wix-forms-formParagraphFont-size)',
        fontFamily: 'var(--wix-forms-formParagraphFont-family)',
        color: 'rgb(var(---wix-forms-formParagraphColor))',
    },
};
const RICOS_THEME = { customStyles: paragraphCustomStylesWUT };
export const SubmitThankYouMessage = ({ messageText, }) => {
    const customTheme = useRicosTheme(RICOS_THEME);
    if (!messageText) {
        return null;
    }
    return (React.createElement(RicosViewer, { dataHook: DATA_HOOKS.SUBMIT_THANK_YOU_MESSAGE, content: messageText, customTheme: customTheme, className: styles.thankYouMessage }));
};
//# sourceMappingURL=submit-thank-you-message.js.map